import { render } from "./CaricamentoFileFornitori.vue?vue&type=template&id=4172688a&scoped=true"
import script from "./CaricamentoFileFornitori.vue?vue&type=script&lang=js"
export * from "./CaricamentoFileFornitori.vue?vue&type=script&lang=js"

import "./CaricamentoFileFornitori.vue?vue&type=style&index=0&id=4172688a&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4172688a"]])

export default __exports__